import { Sparkles, PauseCircle, Play, Inbox, Loader2, XCircle, Clock, Flame, Zap } from "lucide-react";

const CHIP = {
  due: { label: "Due today", cls: "bg-amber-100 text-amber-800", Icon: Clock },
  cold: { label: "Going cold", cls: "bg-rose-100 text-rose-700", Icon: Flame },
  new: { label: "New", cls: "bg-emerald-100 text-emerald-700", Icon: Zap },
};
const OUTBOX = {
  pending: { label: "In outbox", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: Inbox },
  sending: { label: "Sending…", cls: "bg-cyan-50 text-cyan-700 border-cyan-200", Icon: Loader2 },
  failed: { label: "Send failed", cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle },
  skipped: { label: "Skipped", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: XCircle },
};

// AI layer on a Follow-Up Queue card: score, why, next best action, cadence,
// reply/pause state, outbox state, select + AI draft.
export const AiCardStrip = ({ id, ai, outboxStatus, selected, onToggle, onDraft, onResume }) => {
  const stop = (e) => e.stopPropagation();
  const chip = ai && CHIP[ai.chip];
  const ob = OUTBOX[outboxStatus];
  return (
    <div className="mt-2 rounded-lg bg-amber-50/60 border border-amber-100 px-2 py-1.5 space-y-1" onClick={stop} data-testid={`ai-strip-${id}`}>
      {ai?.paused && (
        <div className="flex items-start gap-1.5 text-[11px] text-rose-700" data-testid={`ai-replied-${id}`}>
          <PauseCircle className="w-3.5 h-3.5 mt-px shrink-0" />
          <span className="flex-1 line-clamp-2"><b>Replied · paused</b>{ai.reply_snippet ? ` — “${ai.reply_snippet}”` : ""}</span>
          <button className="font-semibold underline hover:text-rose-900 shrink-0" onClick={() => onResume(id)} data-testid={`ai-resume-${id}`}>
            <Play className="inline w-3 h-3" /> Resume
          </button>
        </div>
      )}
      {ai && !ai.unranked && (
        <>
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="text-[10px] font-bold rounded bg-amber-500 text-white px-1.5 py-0.5" data-testid={`ai-score-${id}`}>
              <Sparkles className="inline w-2.5 h-2.5 mr-0.5" />AI {ai.score}
            </span>
            {chip && <span className={`text-[10px] font-semibold rounded px-1.5 py-0.5 ${chip.cls}`}><chip.Icon className="inline w-2.5 h-2.5 mr-0.5" />{chip.label}</span>}
            <span className="text-[10px] text-slate-500" data-testid={`ai-cadence-${id}`}>{ai.cadence_day}</span>
          </div>
          <p className="text-[11px] text-slate-600 line-clamp-2">{ai.why}</p>
          <p className="text-[11px] font-semibold text-cyan-700">Next: {ai.nba}</p>
        </>
      )}
      <div className="flex items-center gap-2 pt-0.5">
        {ob && <span className={`text-[10px] font-semibold rounded border px-1.5 py-0.5 ${ob.cls}`} data-testid={`ai-outbox-${id}`}>
          <ob.Icon className={`inline w-2.5 h-2.5 mr-0.5 ${outboxStatus === "sending" ? "animate-spin" : ""}`} />{ob.label}</span>}
        <label className="flex items-center gap-1 text-[11px] text-slate-500 cursor-pointer">
          <input type="checkbox" checked={!!selected} onChange={() => onToggle(id)} className="accent-amber-500" data-testid={`ai-select-${id}`} /> Select
        </label>
        <button className="ml-auto text-[11px] font-bold text-amber-700 hover:text-amber-900 inline-flex items-center gap-1" onClick={() => onDraft(id)} data-testid={`ai-draft-${id}`}>
          <Sparkles className="w-3 h-3" /> AI draft
        </button>
      </div>
    </div>
  );
};
